import React, { useEffect, useState } from "react";
import axios from "axios";
import { packClasses } from "Utils";
import { toast } from "react-hot-toast";

let responseChaosInterceptor = null;

/**
 * Eets is a super simple chaos monkey. He'll randomly throw request errors and break various aspects of the app.
 */

export function enableRequestChaos() {
    console.warn("Eets the Chaos Monkey is enabled - @('_')@");

    responseChaosInterceptor = axios.interceptors.request.use((config) => {
        if (Math.random() < 0.1) {
            console.warn(
                "Eets the Chaos Monkey is throwing an error - @('_')@",
                config
            );
            throw new Error("Eets borked your request - @('_')@");
        }
        return config;
    });
}

export function disableRequestChaos() {
    console.warn("Eets the Chaos Monkey is disabled - @('_')@");
    axios.interceptors.request.eject(responseChaosInterceptor);
}

export default function ChaosMonkey(props) {
    const [state, setState] = useState(false);

    useEffect(() => {
        if (
            process.env.NODE_ENV === "development" &&
            process.env.NO_CHAOS !== true
        ) {
            if (state) {
                toast("Eets, the Chaos Monkey, is enabled");
                enableRequestChaos();
            } else {
                toast("Eets, the Chaos Monkey, is disabled");
                disableRequestChaos();
            }
        }
    }, [state]);

    if (
        process.env.NODE_ENV === "development" &&
        process.env.NO_CHAOS !== true
    ) {
        return (
            <div
                className={packClasses(
                    state ? "opacity-100" : "opacity-30",
                    "fixed bottom-1 left-1 cursor-pointer text-xs text-red-300 hover:opacity-50"
                )}
                onClick={() => setState(!state)}
            >
                @('_')@
            </div>
        );
    } else {
        return null;
    }
}
